import { CustomAction } from "..";
import { ServiceEntity } from "../../types/services";
import { SERVICES_ACTION_TYPES } from "../actions-types";

export interface ServicesState {
  services: ServiceEntity[];
  isServicesLoading: boolean;
  selectedServices: string[];
  servicesHasErrors: boolean;
}

const defaultState: ServicesState = {
  services: [],
  isServicesLoading: true,
  selectedServices: [],
  servicesHasErrors: false,
};

const serviceReducer = (state = defaultState, action: CustomAction) => {
  switch (action.type) {
    case SERVICES_ACTION_TYPES.SET_SERVICES:
      return {
        ...state,
        services: action.data,
        isServicesLoading: false,
        servicesHasErrors: false,
      };
    case SERVICES_ACTION_TYPES.SET_SERVICES_LOADING:
      return {
        ...state,
        isServicesLoading: true,
      };
    case SERVICES_ACTION_TYPES.SET_SERVICES_LOADING_FALSE:
      return {
        ...state,
        isServicesLoading: false,
      };
    case SERVICES_ACTION_TYPES.SET_SELECTED_SERVICES:
      return {
        ...state,
        selectedServices: action.data,
      };
    case SERVICES_ACTION_TYPES.SET_SERVICES_HAS_ERRORS:
      return {
        ...state,
        servicesHasErrors: true,
        isServicesLoading: false,
      };
    default:
      return state;
  }
};

export default serviceReducer;
